/*
 * @Author: qiaohui 2323468356@qq.com
 * @Date: 2021-01-08 10:31:30
 * @LastEditors: qiaohui 2323468356@qq.com
 * @LastEditTime: 2023-05-17 17:57:53
 * @FilePath: /chongqing_ringtone/src/request/api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from './http';
// import {
//   baseUrl,
// } from './config';

const baseUrl = 'https://api.guoyifang55.com';
// const baseUrl = 'http://192.168.18.16:9999';
// const baseUrl = 'http://8.149.247.1:10091';
// const baseUrl = 'https://test.guoyifang55.com/api';

const api = {
  // 课程详情  appClass/getAppClassInfo?classId=${that.data.currentId}
  getClassDetails(data) {
    return axios.get(`${baseUrl}/appClass/getAppH5ClassInfo`, {
      params: data
    });
  },
  getOpenid(data){
    return axios.get(`https://api.weixin.qq.com/sns/oauth2/access_token`, {
      params: data
    });
  },

  // 活动详情  appActivity/getActivityById?id=${that.data.currentId}  getH5ActivityById
  getActivityDetails(data){
    return axios.get(`${baseUrl}/appActivity/getH5ActivityById`, {
      params: data
    });
  },


  // 夏令营详情  appSummer/getSummerById?id=${that.data.currentId}
  getSummerDetails(data){
    return axios.get(`${baseUrl}/appSummer/getH5SummerById`, {
      params: data
    });
  },

  // 获取城市书院列表
  getCityList(data){
    return axios.get(`${baseUrl}/bookstore/getBookstoreList`, {
      params: data
    });
  },

  // 获取价格明细
  getPriceData(data){
    return axios.get(`${baseUrl}/appClass/getH5ClassPriceInfo`, {
      params: data
    });
  },

  //  提交订单  
  createdOrder(data) {
    return axios.post(`${baseUrl}/appClass/classH5Registration`,
      data
    );
  },
  // 获取小孩信息
  getChildInfoData(data){
    return axios.get(`${baseUrl}/app/child/getChildInfo`, {
      params: data
    });
  },
  // 获取夏令营价格明细
  getChildPriceData(data){
    return axios.get(`${baseUrl}/app/child/getSummerH5ClassPriceInfo`, {
      params: data
    });
  },
  // 字典接口 
  selectTree(data){
    return axios.get(`${baseUrl}/app/dict/selectTree`, {
      params: data
    });
  },
  // 提交表单 
  saveChildFun(data) {
    return axios.post(`${baseUrl}/app/child/addChildInfo`,
      data
    );
  },
  // 根据身份证查询小孩信息
  queryChildInfo(data){
    return axios.get(`${baseUrl}/app/child/getChildByIdentityNum`, {
      params: data
    });
  },
  // 报名完补全小孩信息 
  complateChildInfo(data){
    return axios.post(`${baseUrl}/app/child/h5PayAfterCompletionChildInfo`,
      data
    );
  },

  //夏令营h5报名完后提交信息  
  commitChildInfo(data) {
    return axios.post(`${baseUrl}/app/child/commitChildInfo`,
      data
    );
  },
  // 提交招生表单 
  commitInfo(data) {
    return axios.post(`${baseUrl}/otherUser/commitInfo`,
      data
    );
  }, 



};

export default api;